<template>
  <wf-login-form />
</template>
<script>
import WfLoginForm from '@/components/business/login/wf-login-form.vue'
export default {
  name: 'WfLogin',
  components: { WfLoginForm }
}
</script>
